import ApiBase from './ApiBase'

const ENDPOINT = process.env.DLINK_ENDPOINT
const DLINK_DOMAIN = process.env.DLINK_DOMAIN

class DynamicLinkApi extends ApiBase {
  shorten (longurl) {
    return fetch(`${ENDPOINT}`, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        longDynamicLink: `${DLINK_DOMAIN}/?link=${longurl}`
      })
    }).then(response => {
      return response.json()
    }).then(json => {
      const shorturl = json.shortLink || null
      console.log('shortened', shorturl, longurl)
      return shorturl
    })
  }
}
export default new DynamicLinkApi()



// WEBPACK FOOTER //
// ./src/api/DynamicLinkApi.js